export default "__VITE_ASSET__C9AJ4vI2__"